import FontAwesomeIcon from 'src/components/Icon';
import Checkbox from 'src/components/Checkbox';

interface GroupedHeaderControlsProps {
  data: any;
  onExpandGroup: any;
  onContractGroup: any;
  isSelected: any;
  onSelectGroup: any;
  onDeleteGroup: any;
}

const GroupedHeaderControls = ({
  data,
  onExpandGroup,
  onContractGroup,
  isSelected,
  onSelectGroup,
  onDeleteGroup,
}: GroupedHeaderControlsProps) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Checkbox
      onChange={() => onSelectGroup()}
      name={data.id}
      value={isSelected}
      readOnly
    />
    {data.isExpanded ? (
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => onContractGroup(data.id)}
      >
        <FontAwesomeIcon glyph="angle-up" weight="regular" size="big" />
      </div>
    ) : (
      <div style={{ cursor: 'pointer' }} onClick={() => onExpandGroup(data.id)}>
        <FontAwesomeIcon glyph="angle-down" weight="regular" size="big" />
      </div>
    )}

    <div
      style={{ cursor: 'pointer', marginLeft: '1rem' }}
      onClick={() => onDeleteGroup(data.id)}
    >
      <FontAwesomeIcon glyph="object-ungroup" weight="regular" size="big" />
    </div>
  </div>
);

export default GroupedHeaderControls;
